import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface IShopSummaryService {
    getShopSummary(shopId: string): angular.IPromise<apsViewModels.ShopSummary>;
}

export class ShopSummaryServiceImpl implements IShopSummaryService {

    httpService: HttpService;

    constructor(httpService: HttpService) {
        this.httpService = httpService;
    }

    getShopSummary(shopId: string): angular.IPromise<apsViewModels.ShopSummary> {
        return this.httpService.get(
            Endpoints.DASHBOARD_SHOPSUMMARY,
            {
                shopId: shopId
            });
    }
}

export default angular
    .module('aps.services.shopSummary', [HttpServiceName])
    .service('shopSummaryService', ShopSummaryServiceImpl)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/shopSummary.service.ts